import { FC } from 'react';

import Alert from 'components/Alert/Alert';

import { AlertType } from 'constants/enums';

import { useTranslation } from 'react-i18next';
import styles from './InterviewCanceled.module.scss';

const InterviewCanceled: FC = () => {
  const { t } = useTranslation()
  return (
    <>
      <h2 className={styles.title}>{t('sidebar.application.interview.canceled.title')}</h2>
      <Alert
        type={AlertType.Warning}
        message={t('sidebar.application.interview.canceled.message')}
        className={styles.alert}
      />
    </>
  );
};

export default InterviewCanceled;
